export default __webpack_public_path__ + "static/media/Tarim's Blade of Sanctity.3ac1d646.jpg";